import type { RegistrationInfoDto } from '../dto';
import type { RegistrationInfo } from '../models';

export function mapRegistrationInfoFromDto(dto: RegistrationInfoDto): RegistrationInfo {
  return {
    firstName: dto.first_name,
    lastName: dto.last_name,
    email: dto.email,
    firmName: dto.firm_name,
  };
}
